import propTypes from "prop-types"
import Swal from 'sweetalert2'
import '../views/formations-page.css'
import './cpf-modal.css'
import DateTable from "./dateTable"

const FormationText = (props) => {
	const titleFormation = props.downloadLink.split('.')[0].toUpperCase();

	function afficherModalitesCPF() {
		Swal.fire({
			title: "Modalités d'inscription CPF",
			html: `
				<ol class="cpf-modal-steps">
					<li><span class="cpf-modal-step-number">1</span><span class="cpf-modal-step-text">Connectez-vous sur <a href="https://www.moncompteformation.gouv.fr" target="_blank" rel="noreferrer">moncompteformation.gouv.fr</a> via France Connect.</span></li>
					<li><span class="cpf-modal-step-number">2</span><span class="cpf-modal-step-text">Recherchez la formation souhaitée à l'aide du lien "Demander un devis via mon CPF" disponible sur la page de la formation, ou en recherchant Bureau Preventicas / le numéro RS de la formation.</span></li>
					<li><span class="cpf-modal-step-number">3</span><span class="cpf-modal-step-text">Vérifiez votre solde CPF disponible et complétez, si besoin, avec un autre mode de financement (OPCO, France Travail, financement personnel...).</span></li>
					<li><span class="cpf-modal-step-number">4</span><span class="cpf-modal-step-text">Validez votre demande d'inscription en ligne.</span></li>
					<li><span class="cpf-modal-step-number">5</span><span class="cpf-modal-step-text">Bureau Preventicas reçoit votre demande et vous confirme votre inscription ainsi que les dates de session.</span></li>
				</ol>
				<p class="cpf-modal-note">Pour toute question sur votre dossier, contactez-nous directement.</p>
			`,
			showCloseButton: true,
			showConfirmButton: true,
			confirmButtonText: "Compris",
			buttonsStyling: false,
			customClass: {
				popup: 'cpf-modal-popup',
				title: 'cpf-modal-title',
				confirmButton: 'btn btn-download cpf-modal-confirm'
			}
		})
	}

	return (
		<div className="text-div">
			<div className="hide-mobile">
				<h5 className="mb-3">Taux de satisfaction global : {props.tauxSatisfaction} % </h5>
					{(props.nomFormation === "CSPS" || props.nomFormation === "SS3" || props.nomFormation === "SS4") &&
						<div className="mb-3">
							<h5 className="mb-2">Formation éligible au CPF / France Travail</h5>
							<button onClick={afficherModalitesCPF} className="btn btn-download">Modalités d'inscription CPF</button>
						</div>
					}
				<DateTable formation={titleFormation}/>
			</div>
		</div>
	)
}

export default FormationText

FormationText.defaultProps = {
	objectif: 'Description des objectifs',
	downloadLink: "RE.pdf",
	nomFormation: "",
	showEvalPeda: true,
	isDiagnostiqueur: false,
	tauxSatisfaction: "N/A"
}

FormationText.propTypes = {
	objectif: propTypes.string,
	downloadLink: propTypes.string,
	nomFormation: propTypes.string,
	isDiagnostiqueur: propTypes.bool,
	showEvalPeda: propTypes.bool,
	tauxSatisfaction: propTypes.string
}

// Nouveaux props pour les informations d'enregistrement
FormationText.defaultProps = Object.assign({}, FormationText.defaultProps, {
	numeroRS: '',
	eligibleCPF: false,
	dateDebutParcours: '',
	dateEcheanceEnregistrement: '',
	lienFranceCompetences: '',
	arrete: '',
	certificateur: ''
})

FormationText.propTypes = Object.assign({}, FormationText.propTypes, {
	numeroRS: propTypes.string,
	eligibleCPF: propTypes.oneOfType([propTypes.bool, propTypes.string]),
	dateDebutParcours: propTypes.string,
	dateEcheanceEnregistrement: propTypes.string,
	lienFranceCompetences: propTypes.string,
	arrete: propTypes.string,
	certificateur: propTypes.string
})
